// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProfileCardSkeleton-profileCardSkeletonBox-AB9Rm {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: flex-start;
  gap: 12px;
  grid-gap: 12px;
  background: var(--background-primary);
  padding: 24px;
  margin-bottom: 6px;
  border-radius: var(--radius-3) var(--radius-3) 0 0;
}

.ProfileCardSkeleton-profileCardImgSkeleton-kp4lF {
  position: relative;
  width: 62px;
  height: 62px;
  border-radius: var(--radius-1);
  background: var(--skeleton-secondary-bg);
  -ms-flex-negative: 0;
      flex-shrink: 0;
}

.ProfileCardSkeleton-profileCardInfoBoxSkeleton-xKVL2 {
  -webkit-box-flex: 1;
      -ms-flex-positive: 1;
          flex-grow: 1;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: flex-start;
  gap: 2px;
  grid-gap: 2px;
}

.ProfileCardSkeleton-profileCardInfoTitleSkeleton-s2Wgy,
.ProfileCardSkeleton-profileCardInfoDesSkeleton-QRh9d {
  background: var(--skeleton-secondary-bg);
  border-radius: var(--radius-5);
}

.ProfileCardSkeleton-profileCardInfoTitleSkeleton-s2Wgy {
  max-width: 66px;
  height: 28px;
}

.ProfileCardSkeleton-profileCardInfoDesSkeleton-QRh9d {
  max-width: 120px;
  height: 26px;
}

@media (max-width: 767px) {
  .ProfileCardSkeleton-profileCardSkeletonBox-AB9Rm {
    padding: 18px;
  }

  .ProfileCardSkeleton-profileCardImgSkeleton-kp4lF {
    width: 48px;
    height: 48px;
  }

  .ProfileCardSkeleton-profileCardInfoTitleSkeleton-s2Wgy {
    height: 26px;
  }
}

@media (max-width: 575px) {
  .ProfileCardSkeleton-profileCardInfoBoxSkeleton-xKVL2 {
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Skeleton/ViewBooking/ProfileCardSkeleton/ProfileCardSkeleton.css"],"names":[],"mappings":"AAAA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,qCAAqC;EACrC,aAAa;EACb,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,wCAAwC;EACxC,oBAAc;MAAd,cAAc;AAChB;;AAEA;EACE,mBAAY;MAAZ,oBAAY;UAAZ,YAAY;EACZ,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,QAAQ;EACR,aAAa;AACf;;AAEA;;EAEE,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,mBAAe;QAAf,eAAe;EACjB;AACF","sourcesContent":[".profileCardSkeletonBox {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  grid-gap: 12px;\n  background: var(--background-primary);\n  padding: 24px;\n  margin-bottom: 6px;\n  border-radius: var(--radius-3) var(--radius-3) 0 0;\n}\n\n.profileCardImgSkeleton {\n  position: relative;\n  width: 62px;\n  height: 62px;\n  border-radius: var(--radius-1);\n  background: var(--skeleton-secondary-bg);\n  flex-shrink: 0;\n}\n\n.profileCardInfoBoxSkeleton {\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 2px;\n  grid-gap: 2px;\n}\n\n.profileCardInfoTitleSkeleton,\n.profileCardInfoDesSkeleton {\n  background: var(--skeleton-secondary-bg);\n  border-radius: var(--radius-5);\n}\n\n.profileCardInfoTitleSkeleton {\n  max-width: 66px;\n  height: 28px;\n}\n\n.profileCardInfoDesSkeleton {\n  max-width: 120px;\n  height: 26px;\n}\n\n@media (max-width: 767px) {\n  .profileCardSkeletonBox {\n    padding: 18px;\n  }\n\n  .profileCardImgSkeleton {\n    width: 48px;\n    height: 48px;\n  }\n\n  .profileCardInfoTitleSkeleton {\n    height: 26px;\n  }\n}\n\n@media (max-width: 575px) {\n  .profileCardInfoBoxSkeleton {\n    flex-wrap: wrap;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"profileCardSkeletonBox": `ProfileCardSkeleton-profileCardSkeletonBox-AB9Rm`,
	"profileCardImgSkeleton": `ProfileCardSkeleton-profileCardImgSkeleton-kp4lF`,
	"profileCardInfoBoxSkeleton": `ProfileCardSkeleton-profileCardInfoBoxSkeleton-xKVL2`,
	"profileCardInfoTitleSkeleton": `ProfileCardSkeleton-profileCardInfoTitleSkeleton-s2Wgy`,
	"profileCardInfoDesSkeleton": `ProfileCardSkeleton-profileCardInfoDesSkeleton-QRh9d`
};
module.exports = ___CSS_LOADER_EXPORT___;
